export const enum LockColor  {
    LOCKED = '#E7C022',
    UNLOCKED = '#28B463',
    AUTO_LOCKED = '#D22B2B'
}